export const routes = {
    ROOT: '/',
    HOME: '/home',
    HOME_MODULE: '/home/:moduleName',
    SALES: '/sales',
    SALES_MODULE: '/sales/:moduleName',
    EXPERT: '/expert',
    EXPERT_MODULE: '/expert/:moduleName',
    LOGIN: '/login',
    LOGIN_SSO: '/sso-login',
    CHANGE_PASSWORD: '/change-password',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    SETTINGS: '/settings',
    SETTINGS_ADMIN: '/admin',
    SETTINGS_USER: '/user-settings',
    SETTINGS_USER_GENERAL: '/user-settings/general',
    SETTINGS_USER_NOTIFICATIONS: '/user-settings/notifications',
    TEMPLATES: '/settings/templates',
    EDIT_TEMPLATE: '/settings/templates/edit',
    DEALER_SELECTOR: '/dealer-selector',
    BUSINESS_UNIT_SELECTOR: '/business-unit-selector',
    BUSINESS_UNIT_BRAND_SELECTOR: '/business-unit-brand-selector',
    NETWORK_OVERVIEW: '/network-overview',
    CONFIRM_DELIVERY: '/confirm-delivery/:tradeInId',
    PHYSICAL_PROCESS_WORKSHOP: '/physical-process-workshop/:physicalProcessId',
}

// BACKEND API ENDPOINTS
export const settingsAPIs = {
    [routes.SETTINGS_USER_GENERAL]: '/users/forms/settings',
    BUSINESS_UNIT: '/network/business-units',
}

export const settingsEndpoints = {
    APP_SETTINGS: '/settings/settings',
    DOCUMENT_TEMPLATE_PARTS: '/settings/document-template-parts',
    DOCUMENT_TEMPLATE_PART: '/settings/document-template-parts/:documentTemplatePartId',
    DOCUMENT_APPENDICES: '/:module/document-appendices',
    DOCUMENT_APPENDIX: '/:module/document-appendices/:appendixId',
    DOCUMENT_APPENDIX_TAGS: '/:module/document-tags',
}

const authApiEndpoints = {
    LOGIN: '/auth/log-in',
    LOGIN_SSO: '/auth/log-in-sso',
    LOGIN_ACTIVE_TENANT: '/auth/log-in/active-tenant',
    VALIDATE_MFA: '/auth/validate-mfa',
    REFRESH_TOKEN: '/auth/refresh',
    FORGOT_PASSWORD: '/auth/password/forgot',
    RESET_PASSWORD: '/auth/password/reset',
    VALIDATE_REDIRECT: '/auth/validate-redirect',
}

const emailsApiEndpoints = {
    EMAIL_TEMPLATES: '/emails/templates',
    EMAIL_TEMPLATES_SETTINGS: '/emails/templates/settings',
    EMAIL_TEMPLATE: '/emails/templates/:templateKey',
}

const formApiEndpoints = {
    BUSINESS_UNIT_FORM: '/users/forms/business-units',
    LEGAL_ENTITY_FORM: '/users/forms/legal-entities',
    COMMERCIAL_ENTITY_FORM: '/users/forms/commercial-entities',
}

const damagesApiEndpoints = {
    DAMAGE: '/inspection/damages/:damageId',
    DAMAGE_LOCATIONS: '/inspection/damage-locations',
    DAMAGE_LOCATION: '/inspection/damage-locations/:damageLocationId',
    DAMAGE_LOCATION_KEY: '/inspection/damage-locations/key/:key',
    DAMAGE_TYPE: '/inspection/damage-types/:damageTypeId',
    INSPECTION_DAMAGE: '/inspection/inspections/:inspectionId/damages',
    NO_DAMAGES: '/inspection/inspections/:inspectionId/no-damages',
}

const optionsApiEndpoints = {
    UNIQUE_OPTIONS: '/asset/assets/:assetId/options-unique',
    UNIQUE_OPTION: '/asset/assets/:assetId/options-unique/:optionId',
    CUSTOM_OPTIONS: '/asset/options-custom',
    GENERIC_OPTIONS: '/asset/options-generic',
    GROUPED_OPTIONS_STANDARDIZED: '/asset/options-standardized',
    INSPECTION_GROUPED_OPTIONS_STANDARDIZED: '/asset/assets/:assetId/options-standardized',
    CREATE_OR_UPDATE_INSPECTION_OPTIONS_STANDARDIZED:
        '/asset/assets/:assetId/options-standardized/create_or_update_many',
    CREATE_OR_UPDATE_INSPECTION_OPTIONS_CUSTOM: '/asset/assets/:assetId/options-custom/create_or_update_many',
}

const uploadApiEndpoints = {
    UPLOAD_IMAGE: '/media/images/upload',
    UPLOAD_IMAGES: '/media/images/upload-multiple',
    UPLOAD_DOCUMENT: '/media/documents/upload',
}

const inspectionEndpoints = {
    POSITIVE_NOTES: '/inspection/inspections/:inspectionId/positive-notes',
    NEGATIVE_NOTES: '/inspection/inspections/:inspectionId/negative-notes',
    INTERNAL_NOTES: '/inspection/inspections/:inspectionId/internal-notes',
    INSPECTION_MEDIA: '/inspection/inspections/:inspectionId/media',
    INSPECTION_MEDIA_ITEM: '/inspection/inspections/:inspectionId/media/:mediaId',
}

const inspectionPictureEndpoints = {
    PICTURE_TYPES: '/inspection/picture-types',
    ADD_INSPECTION_PICTURES: '/inspection/inspections/:inspectionId/pictures/create_or_update_many',
    DOCUMENT_TYPES: '/inspection/document-types',
    ADD_INSPECTION_DOCUMENTS: '/inspection/inspections/:inspectionId/documents/create_or_update_many',
}

export const tradeInEndpoints = {
    TRADE_IN_INIT: '/inspection/trade-ins/initialize',
    TRADE_IN: '/inspection/trade-ins/:tradeInId',
    TRADE_INS: '/inspection/trade-ins',
    TRADE_IN_CATEGORIES: '/inspection/trade-ins/categories',
    TRADE_IN_DUPLICATE: '/inspection/trade-ins/:tradeInId/duplicate',
    INSPECTION_CHECKS: '/inspection/checks',
    UPDATE_INSPECTION_CHECKS: '/inspection/inspections/:inspectionId/checks/create_or_update_many',
    ASSIGN_TRADE_IN_TO_ME: '/inspection/trade-ins/:tradeInId/assign-to-me',
    ASSIGN_TRADE_IN_TO: '/inspection/trade-ins/:tradeInId/assign-to',
    UPDATE_TRADE_IN_CUSTOMER: '/inspection/trade-ins/:tradeInId/private-customer',
    UPDATE_TRADE_IN_COMPANY: '/inspection/trade-ins/:tradeInId/professional-customer',
    UPDATE_TRADE_IN_OPPORTUNITY: '/inspection/trade-ins/:tradeInId/opportunity',
    SAVE_TAX_INFO: '/inspection/trade-ins/:tradeInId/customer/taxation-information',
    EXPECTATIONS: '/inspection/trade-ins/:tradeInId/expectations',
    PROPOSALS: '/inspection/trade-ins/:tradeInId/proposals',
    TRADE_IN_HISTORY: '/inspection/trade-ins/:tradeInId/events',
    TRADERS: '/inspection/traders',
    APPROVE_TRADER: '/inspection/traders/:traderId/approve',
    LOCK_TRADER: '/inspection/traders/:traderId/lock',
    MARK_TRADER_INTERNAL: '/inspection/traders/:traderId/mark-internal',
    MARK_TRADER_NOT_INTERNAL: '/inspection/traders/:traderId/mark-not-internal',
    INSPECTION_MILEAGE: '/inspection/inspections/:inspectionId/mileage',
    INSPECTION_REGISTRATION: '/inspection/inspections/:inspectionId/registration',
    ENTRY_DATA: '/inspection/trade-ins/:tradeInId/intake-data',
    TRADE_IN_DOCUMENT_TYPES: '/inspection/trade-ins/:tradeInId/document-types',
    TRADE_IN_DOCUMENT_DOWNLOADS: '/inspection/trade-ins/:tradeInId/document-downloads',
    TRADE_IN_DOCUMENT_DOWNLOAD: '/inspection/trade-ins/:tradeInId/document-downloads/:requestId',
    TRADE_IN_DOCUMENT_DOWNLOAD_CONTENT: '/inspection/trade-ins/:tradeInId/document-downloads/:requestId/content',
    SEND_TO_DMS_SOLD: '/inspection/trade-ins/:tradeInId/dms-sold-to-trader',
    SEND_TO_DMS_ENTER: '/inspection/trade-ins/:tradeInId/dms-enter',
    TRADE_IN_COMMENTS: '/inspection/trade-ins/:tradeInId/comments',
}

export const tradeInActionEndpoints = {
    TRADE_IN_CONFIRM: '/inspection/trade-ins/:tradeInId/confirm',
    TRADE_IN_RE_OPEN: '/inspection/trade-ins/:tradeInId/re-open',
    TRADE_IN_PUBLISH: '/inspection/trade-ins/:tradeInId/publish',
    TRADE_IN_UNPUBLISH: '/inspection/trade-ins/:tradeInId/unpublish',
    TRADE_IN_REFUSE: '/inspection/trade-ins/:tradeInId/refuse-proposal',
    TRADE_IN_ACCEPT: '/inspection/trade-ins/:tradeInId/accept-proposal',
    TRADE_IN_UNDO_REFUSAL: '/inspection/trade-ins/:tradeInId/undo-refusal-proposal',
    TRADE_IN_WITHDRAW: '/inspection/trade-ins/:tradeInId/withdraw-proposal',
    TRADE_IN_REVERT_FROM_BUFFER: '/inspection/trade-ins/:tradeInId/revert-from-buffer',
    TRADE_IN_ASSIGN_MANAGER: '/inspection/trade-ins/:tradeInId/assign-manager',
    TRADE_IN_UNASSIGN_MANAGER: '/inspection/trade-ins/:tradeInId/unassign-manager',
    TRADE_IN_REQUEST_REVIEW: '/inspection/trade-ins/:tradeInId/request-review',
    TRADE_IN_EVENT: '/inspection/trade-ins/:tradeInId/events',
    TRADE_IN_VALIDATE: '/inspection/trade-ins/:tradeInId/validate',
    TRADE_IN_ENTER: '/inspection/trade-ins/:tradeInId/enter',
    TRADE_IN_INTAKE: '/inspection/trade-ins/:tradeInId/intake',
    TRADE_IN_TRANSFER: '/inspection/trade-ins/:tradeInId/transfer',
    TRADE_IN_DELIVER: '/inspection/trade-ins/:tradeInId/deliver',
    TRADE_IN_READY_FOR_PAYMENT: '/inspection/trade-ins/:tradeInId/ready-for-payment',
    TRADE_IN_CANCEL_READY_FOR_PAYMENT: '/inspection/trade-ins/:tradeInId/cancel-ready-for-payment',
    TRADE_IN_PAID: '/inspection/trade-ins/:tradeInId/paid',
    TRADE_IN_DISPATCH: '/inspection/trade-ins/:tradeInId/dispatch',
    TRADE_IN_ARCHIVE: '/inspection/trade-ins/:tradeInId/archive',
    TRADE_IN_ALL_CHANNELS: '/inspection/trade-ins/channels',
    TRADE_IN_FORCE_TO_DELIVERED: '/inspection/trade-ins/:tradeInId/force-to-delivered',
    TRADE_IN_FORCE_TO_PAID: '/inspection/trade-ins/:tradeInId/force-to-paid',
    TRADE_IN_FORCE_TO_SOLD: '/inspection/trade-ins/:tradeInId/force-to-sold',
    TRADE_IN_FORCE_TO_ENTERED: '/inspection/trade-ins/:tradeInId/force-to-entered',
}

export const imageSetsEndpoints = {
    IMAGE_SETS: '/sale/image-sets',
    IMAGE_SET: '/sale/image-sets/:imageSetId',
    IMAGE_SET_BANNER_IMAGES: '/sale/image-sets/:imageSetId/banner-images',
    IMAGE_SET_BANNER_IMAGE: '/sale/image-sets/:imageSetId/banner-images/:bannerImageId',
    IMAGE_SET_BANNER_IMAGES_CREATE: '/sale/image-sets/:imageSetId/banner-images',
    IMAGE_SET_COMMERCIAL_IMAGES: '/sale/image-sets/:imageSetId/commercial-images',
    IMAGE_SET_COMMERCIAL_IMAGE: '/sale/image-sets/:imageSetId/commercial-images/:commercialImageId',
    IMAGE_SET_COMMERCIAL_IMAGES_CREATE: '/sale/image-sets/:imageSetId/commercial-images',
}

export const publicationEndpoints = {
    PUBLICATION_INIT: '/sale/publications/initialize',
    PUBLICATION: '/sale/publications/:publicationId',
    PUBLICATION_LIST: '/sale/publications',
    WARRANTY: '/sale/publications/:publicationId/warranty-duration',
    WARRANTY_LOCATION: '/sale/publications/:publicationId/assign-location',
    PUBLICATION_HTML_BLOCKS: '/sale/publications/:publicationId/html-blocks',
    UPDATE_PUBLICATION_HTML_BLOCKS: '/sale/publications/:publicationId/html-blocks/create_or_update_many',
    INTERNAL_LABEL: '/sale/internal-labels/:internalLabelId',
    INTERNAL_LABELS: '/sale/internal-labels',
    INTERNAL_PUBLICATION_LABELS: '/sale/publications/internal-labels',
    UPDATE_INTERNAL_PUBLICATION_LABELS: '/sale/publications/:publicationId/internal-labels/create_or_update_many',
    PUBLICATION_DISTRIBUTOR_LABELS: '/sale/publications/distributor-labels',
    PUBLICATION_DISTRIBUTOR_LABEL: '/sale/publications/:publicationId/distributor-label',
    CONTROL_POINTS: '/sale/control-point-groups',
    UPDATE_CONTROL_POINTS: '/sale/publications/:publicationId/control-points/create_or_update_many',
    ODOMETER_SERVICE: '/sale/publications/:publicationId/update-odometer-reading',
    ODOMETER_SERVICE_DOCUMENT: '/sale/publications/:publicationId/odometer-reading-document',
    PUBLICATION_BATTERY_CERTIFICATE_DOCUMENT: '/sale/publications/:publicationId/battery-certificate-document',
    ODOMETER_CREDENTIALS: '/sale/odometer-credentials',
    ODOMETER_CREDENTIAL: '/sale/odometer-credentials/:credentialsId',
    ALL_PUBLICATION_CHANNELS: '/sale/publications/publication-channels',
    PUBLICATION_PUBLICATION_CHANNELS: '/sale/publications/:publicationId/publication-channels',
    PUBLICATION_CATEGORIES: '/sale/publications/categories',
    PUBLICATION_ADD_ONS: '/sale/publication-add-ons',
    PUBLICATION_ADD_ON: '/sale/publication-add-ons/:addOnId',
    PUBLICATION_ADD_ON_LINKED_COUNT: '/sale/publication-add-ons/:addOnId/linked-process-count',
    PUBLICATION_DOCUMENT_TYPES: '/sale/publications/:publicationId/document-types',
    PUBLICATION_DOCUMENT_DOWNLOADS: '/sale/publications/:publicationId/document-downloads',
    PUBLICATION_DOCUMENT_DOWNLOAD: '/sale/publications/:publicationId/document-downloads/:requestId',
    PUBLICATION_DOCUMENT_DOWNLOAD_CONTENT: '/sale/publications/:publicationId/document-downloads/:requestId/content',
    PICTURE_PROVIDERS: '/sale/publications/:publicationId/picture-providers',
    UPDATE_PICTURES_BY_PROVIDER: '/sale/publications/:publicationId/update-pictures-by-provider',
    PUBLICATION_HISTORY: '/sale/publications/:publicationId/history',
    PUBLICATIONS_BULK_UPDATE: '/sale/publications/bulk-update',
}

export const publicationActionEndpoints = {
    PUBLICATION_VALIDATE: '/sale/publications/:publicationId/validate',
    PUBLICATION_PUBLISH: '/sale/publications/:publicationId/publish',
    PUBLICATION_PUBLISH_ALL: '/sale/publications/:publicationId/publish-all',
    PUBLICATION_UNPUBLISH_ALL: '/sale/publications/:publicationId/unpublish-all',
    PUBLICATION_SOLD: '/sale/publications/:publicationId/sell',
    PUBLICATION_DELIVERED: '/sale/publications/:publicationId/deliver',
    PUBLICATION_ARCHIVE: '/sale/publications/:publicationId/archive',
    PUBLICATION_RESERVED: '/sale/publications/:publicationId/reserve',
    PUBLICATION_CANCEL_RESERVATION: '/sale/publications/:publicationId/cancel-reservation',
    PUBLICATION_CHANGE_STATE_TO_INITIAL: '/sale/publications/:publicationId/to-initial',
    PUBLICATION_REVERT_TO_INITIAL: '/sale/publications/:publicationId/revert-to-initial',
    PUBLICATION_FORCE_TO_INITIAL: '/sale/publications/:publicationId/force-to-initial',
    PUBLICATION_FORCE_TO_RESERVED: '/sale/publications/:publicationId/force-to-reserved',
    PUBLICATION_FORCE_TO_SOLD: '/sale/publications/:publicationId/force-to-sold',
    PUBLICATION_DUPLICATE: '/sale/publications/:publicationId/duplicate',
}

export const saleProcessEndpoints = {
    SALE_PROCESS_INIT: '/sale/processes/initialize',
    SALE_PROCESS: '/sale/processes/:saleProcessId',
    SALE_PROCESS_LIST: '/sale/processes',
    SALE_PROCESS_ADDON_RULES: '/sale/process-addon-rules',
    SALE_PROCESS_HISTORY: '/sale/processes/:saleProcessId/history',
    SALE_PROCESS_DOCUMENT_TYPES: '/sale/processes/:saleProcessId/document-types',
    SALE_PROCESS_DOCUMENT_DOWNLOADS: '/sale/processes/:saleProcessId/document-downloads',
    SALE_PROCESS_DOCUMENT_DOWNLOAD: '/sale/processes/:saleProcessId/document-downloads/:requestId',
    SALE_PROCESS_DOCUMENT_DOWNLOAD_CONTENT: '/sale/processes/:saleProcessId/document-downloads/:requestId/content',
    SALE_PROCESS_TO_DMS_SOLD: '/sale/processes/:processId/dms-sold',
    CONTACT_METHOD: '/sale/contact-methods/:contactMethodId',
    CONTACT_METHODS: '/sale/contact-methods',
    DISTRIBUTOR_LABEL: '/sale/distributor-labels/:distributorLabelId',
    DISTRIBUTOR_LABELS: '/sale/distributor-labels',
    FINANCING_TYPES: '/sale/financing-types',
    USAGE_TYPES: '/sale/usage-types',
}

export const saleProcessActionEndpoints = {
    SALE_PROCESS_ARCHIVE: '/sale/processes/:saleProcessId/archive',
    SALE_PROCESS_ASSIGN_TO_ME: '/sale/processes/:saleProcessId/assign-to-me',
    SALE_PROCESS_ASSIGN_TO: '/sale/processes/:saleProcessId/assign-to',
    SALE_PROCESS_LINK_INDIVIDUAL: '/sale/processes/:saleProcessId/individuals/:individualId/link',
    SALE_PROCESS_LINK_COMPANY: '/sale/processes/:saleProcessId/companies/:companyId/link',
    SALE_PROCESS_UNLINK_INDIVIDUAL: '/sale/processes/:saleProcessId/individuals/:individualId/unlink',
    SALE_PROCESS_UNLINK_COMPANY: '/sale/processes/:saleProcessId/companies/:companyId/unlink',
    SALE_PROCESS_PUBLICATION_RELATIONS: '/sale/process-publication-relations',
    SALE_PROCESS_PUBLICATION_RELATIONS_BULK: '/sale/process-publication-relations/bulk',
    SALE_PROCESS_PUBLICATION_RELATION: '/sale/process-publication-relations/:relationId',
    SALE_PROCESS_EVENT: '/sale/processes/:saleProcessId/events',
    SALE_PROCESS_LINK_TRADE_IN: '/sale/processes/:saleProcessId/trade-ins/:tradeInId/link',
    SALE_PROCESS_UNLINK_TRADE_IN: '/sale/processes/:saleProcessId/trade-ins/:tradeInId/unlink',
    SALE_PROCESS_ADDONS: '/sale/process-add-ons',
    SALE_PROCESS_ADDON: '/sale/process-add-ons/:addOnId',
    SALE_PRODUCTS_AND_SERVICES: '/sale/products-and-services',
    SALE_PRODUCT_OR_SERVICE: '/sale/products-and-services/:productOrServiceId',
    SALE_PROCESS_CHOOSE_PUBLICATION: '/sale/process-publication-relations/:relationId/choose',
    SALE_PROCESS_WIN: '/sale/processes/:saleProcessId/win',
    SALE_PROCESS_LOSE: '/sale/processes/:saleProcessId/lose',
    SALE_PROCESS_CANCEL: '/sale/processes/:saleProcessId/cancel',
    SALE_PROCESS_RESERVE: '/sale/processes/:saleProcessId/reserve',
    SALE_PROCESS_UNRESERVE: '/sale/processes/:saleProcessId/unreserve',
    SALE_PROCESS_DELIVER: '/sale/processes/:saleProcessId/deliver',
    SALE_PROCESS_REVERT_TO_RESERVED: '/sale/processes/:saleProcessId/revert-to-reserved',
    SALE_PROCESS_REVERT_TO_INITIAL: '/sale/processes/:saleProcessId/revert-to-initial',
}

export const physicalProcessEndpoints = {
    PHYSICAL_ASSETS: '/physical-process/physical-assets/',
    PHYSICAL_ASSET: '/physical-process/physical-assets/:physicalAssetId',
    PHYSICAL_ASSET_HISTORY: '/physical-process/physical-assets/:physicalAssetId/history',
    PHYSICAL_ASSET_ANNOUNCE: '/physical-process/physical-assets/:physicalAssetId/announce',
    PHYSICAL_ASSET_ENTER: '/physical-process/physical-assets/:physicalAssetId/enter',
    PHYSICAL_ASSET_IN_TRANSIT_PREPARATION: '/physical-process/physical-assets/:physicalAssetId/in_transit_preparation',
    PHYSICAL_ASSET_IN_PREPARATION: '/physical-process/physical-assets/:physicalAssetId/in_preparation',
    PHYSICAL_ASSET_READY: '/physical-process/physical-assets/:physicalAssetId/ready',
    PHYSICAL_ASSET_IN_TRANSIT_DELIVERY: '/physical-process/physical-assets/:physicalAssetId/in_transit_delivery',
    PHYSICAL_ASSET_IN_DELIVERY: '/physical-process/physical-assets/:physicalAssetId/in_delivery',
    PHYSICAL_ASSET_DELIVER: '/physical-process/physical-assets/:physicalAssetId/deliver',
    PHYSICAL_ASSET_ARCHIVE: '/physical-process/physical-assets/:physicalAssetId/archive',
    BUYERS: '/physical-process/buyers/',
    SUPPLIERS: '/physical-process/suppliers/',
    PHYSICAL_PROCESS_DOCUMENT_TYPES: '/physical-process/physical-assets/:physicalAssetId/document-types',
    PHYSICAL_PROCESS_DOCUMENT_DOWNLOADS: '/physical-process/physical-assets/:physicalAssetId/document-downloads',
    PHYSICAL_PROCESS_DOCUMENT_DOWNLOAD:
        '/physical-process/physical-assets/:physicalAssetId/document-downloads/:requestId',
    PHYSICAL_PROCESS_DOCUMENT_DOWNLOAD_CONTENT:
        '/physical-process/physical-assets/:physicalAssetId/document-downloads/:requestId/content',
    PHYSICAL_PROCESS_VALUE_COMPLETE: '/physical-process/physical-process-values/:physicalProcessValueId/complete',
    PHYSICAL_PROCESS_VALUE_RESET: '/physical-process/physical-process-values/:physicalProcessValueId/reset',
    PHYSICAL_PROCESS_VALUE_COMPLETE_STEP:
        '/physical-process/physical-process-values/:physicalProcessValueId/complete-step',
    PHYSICAL_PROCESS_VALUE_RESET_STEP: '/physical-process/physical-process-values/:physicalProcessValueId/reset-step',
    CHECKITEM_VALUE: '/physical-process/checkitem-values/:checkitemValueId',
}

export const customerEndpoints = {
    CREATE_CUSTOMER: '/crm/individuals/',
    CUSTOMER: '/crm/individuals/:customerId',
    UPDATE_CUSTOMER: '/crm/individuals/:customerId',
    CUSTOMER_TITLES: '/crm/individual-titles/',
    CUSTOMERS: '/crm/individuals/',
}

export const companyEndpoints = {
    CREATE_COMPANY: '/crm/companies/',
    COMPANY: '/crm/companies/:companyId',
    UPDATE_COMPANY: '/crm/companies/:companyId',
    LEGAL_FORMS: '/crm/legal-forms/',
    COMPANIES: '/crm/companies/',
    VAT_INFO: '/crm/vat-info/',
}

export const assetEndpoints = {
    MAKES: '/asset/makes',
    MODELS: '/asset/makes/:makeId/models',
    VERSIONS: '/asset/models/:modelId/versions',
    BODY_TYPES: '/asset/body-types',
    BODY_COLORS: '/asset/body-colors',
    FUEL_TYPES: '/asset/fuel-types',
    FUEL_CATEGORY: '/asset/fuel-categories',
    GEARBOXES: '/asset/transmissions',
    INTERIOR_COLORS: '/asset/upholstery-colors',
    UPHOLSTERY_TYPES: '/asset/upholstery-types',
    EMISSION_NORMS: '/asset/emission-norms',
    DRIVETRAINS: '/asset/drivetrains',
    VIN_NUMBERS: '/asset/vin-suggestions/',
    VIN_NUMBER: '/asset/vin-data/',
    NATCODE_DATA: '/asset/natcode-data/',
    ASSIGN_NATCODE_DATA: '/asset/:id/natcode-data/',
    ASSET: '/asset/assets/:assetId',
}

export const proposalEndpoints = {
    CHANNELS: '/inspection/trade-ins/:tradeInId/channels',
    BIDS: '/inspection/trade-ins/:tradeInId/bids',
    BID: '/inspection/bids/:bidId',
    ACCEPT_BID: '/inspection/bids/:bidId/accept',
    RETRACT_BID: '/inspection/bids/:bidId/retract',
    DELETE_BID: '/inspection/bids/:bidId/delete',
    PROPOSE: '/inspection/trade-ins/:tradeInId/propose',
    VALUATION_URL: '/inspection/trade-ins/:tradeInId/valuation-url',
}

export const purchaseDocumentsEndpoints = {
    PURCHASE_NOTICE: '/inspection/trade-ins/:tradeInId/purchase-notice',
    SIGNED_PURCHASE_NOTICE: '/inspection/trade-ins/:tradeInId/signed-purchase-notice',
    PURCHASE_ORDER: '/inspection/trade-ins/:tradeInId/purchase-order',
    SIGNED_PURCHASE_ORDER: '/inspection/trade-ins/:tradeInId/signed-purchase-order',
    SIGNED_PURCHASE_INVOICE: '/inspection/trade-ins/:tradeInId/signed-customer-purchase-invoice',
    TRADER_INVOICE: '/inspection/trade-ins/:tradeInId/trader-invoice',
    PROOF_OF_DELIVERY: '/inspection/trade-ins/:tradeInId/proof-of-delivery',
}

export const saleDocumentsEndpoints = {
    DESCRIPTION: '/sale/publications/:publicationId/description',
    WINDSCREEN_DISPLAY: '/sale/publications/:publicationId/windscreen',
}

export const opportunitiesEndpoints = {
    OPPORTUNITIES: '/crm/sales/opportunities',
    OPPORTUNITY: '/crm/sales/opportunities/:opportunityId',
    OPPORTUNITY_CATEGORIES: '/crm/sales/opportunity-categories',
}

export const distributorLabelsBusinessUnitsEndpoints = {
    DISTRIBUTOR_LABELS_BUSINESS_UNITS_RELATIONS: '/sale/distributor-label-business-unit-relations',
    DISTRIBUTOR_LABELS_BUSINESS_UNITS_RELATIONS_BULK: '/sale/distributor-label-business-unit-relations/bulk',
}

export const notificationEndpoints = {
    NOTIFICATION_PREFERENCES: '/notifications/preferences/me',
    NOTIFICATIONS_INBOX: '/notifications/me/inbox',
    NOTIFICATIONS_INBOX_MARK_ALL_AS_READ: '/notifications/me/inbox/mark-all-as-read',
    NOTIFICATION_MARK_AS_READ: '/notifications/me/inbox/:notificationId/mark-as-read',
}

export const API_ENDPOINTS = {
    ANALYTICS: '/users/analytics',
    USERS: '/users/users',
    DEALERS: '/users/dealers',
    DEALERS_FOR_CURRENT_USER: '/users/me/dealers',
    BUSINESS_UNITS: '/users/business-units',
    BUSINESS_UNITS_FOR_CURRENT_USER: '/users/me/business-units',
    BUSINESS_UNIT: '/users/business-units/:businessUnitId',
    BUSINESS_UNIT_BRANDS: '/users/business-units/:businessUnitId/brands',
    BUSINESS_CONFIG_NETWORK: '/users/active-network-config',
    LEGAL_ENTITY: '/users/legal-entities/:legalEntityId',
    COMMERCIAL_ENTITY: '/users/commercial-entities/:commercialEntityId',
    DEALER_BUSINESS_UNITS: '/users/dealer/:dealerId/business-units',
    DEALER_BUSINESS_UNIT_GROUPS: '/users/dealer/:dealerId/business-unit-groups',
    DEALER_BUSINESS_UNIT_GROUP_FILTER_OPTIONS: '/users/dealer/:dealerId/business-unit-groups/filter-options',
    BUSINESS_UNIT_GROUP: '/users/business-unit-groups/:groupId',
    DEALER_LEGAL_ENTITIES: '/users/dealer/:dealerId/legal-entities',
    DEALER_COMMERCIAL_ENTITIES: '/users/dealer/:dealerId/commercial-entities',
    CHANGE_PASSWORD: '/users/password',
    USER_INFO: '/users/me',
    TAX_QUESTIONS: '/crm/taxation-questions/',
    ...settingsEndpoints,
    ...authApiEndpoints,
    ...emailsApiEndpoints,
    ...formApiEndpoints,
    ...damagesApiEndpoints,
    ...optionsApiEndpoints,
    ...uploadApiEndpoints,
    ...inspectionEndpoints,
    ...inspectionPictureEndpoints,
    ...tradeInEndpoints,
    ...customerEndpoints,
    ...companyEndpoints,
    ...assetEndpoints,
    ...tradeInActionEndpoints,
    ...proposalEndpoints,
    ...purchaseDocumentsEndpoints,
    ...opportunitiesEndpoints,
    ...publicationEndpoints,
    ...publicationActionEndpoints,
    ...saleDocumentsEndpoints,
    ...saleProcessEndpoints,
    ...saleProcessActionEndpoints,
    ...physicalProcessEndpoints,
    ...distributorLabelsBusinessUnitsEndpoints,
    ...imageSetsEndpoints,
    ...notificationEndpoints,
}

export const INSPECTION_PREFIX = '/inspection'
